import { render, staticRenderFns } from "./WithdrawalsButton.vue?vue&type=template&id=5971278c&scoped=true"
import script from "./WithdrawalsButton.vue?vue&type=script&lang=ts"
export * from "./WithdrawalsButton.vue?vue&type=script&lang=ts"
import style0 from "./WithdrawalsButton.vue?vue&type=style&index=0&id=5971278c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5971278c",
  null
  
)

export default component.exports